import React from 'react';
import { Feature } from 'core/enums/features';
import { BaseRoute } from 'core/models/base-routes';

export const DashboardRoutes: BaseRoute[] = [
  {
    path: '*',
    title: 'Dashboard',
    name: 'dashboard.tabs.viewing',
    feature: Feature.DashboardViewing,
    component: React.lazy(() => import('./viewing/viewing')),
    hideFromMainMenu: true,
    icon: 'icon-box-office_64',
    isActive: true,
  },
  {
    path: 'internet-product',
    title: 'Dashboard',
    name: 'dashboard.tabs.internet',
    feature: Feature.DashboardInternet,
    component: React.lazy(() => import('./internet/internet')),
    hideFromMainMenu: true,
    icon: 'icon-wifi_32x32',
  },
  {
    path: 'insure',
    title: 'Dashboard',
    name: 'dashboard.tabs.insurance',
    feature: Feature.DashboardInsurance,
    component: React.lazy(() => import('./insurance/insurance')),
    hideFromMainMenu: true,
    icon: 'icon-claim-insurance',
  },
  {
    path: 'safety',
    title: 'Dashboard',
    name: 'dashboard.tabs.safety',
    feature: Feature.DashboardSafety,
    component: React.lazy(() => import('./safety/safety')),
    hideFromMainMenu: true,
    icon: 'icon-box-office_64',
  },
  {
    path: 'inactive',
    title: 'Dashboard',
    name: 'dashboard.tabs.inactive',
    feature: Feature.DashboardInactive,
    component: React.lazy(() => import('./inactive/inactive')),
    hideFromMainMenu: true,
    icon: 'icon-disconnect',
  },
];